import React from 'react';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { PhotoUploader } from './CreateEnquiry/PhotoUploader';
import { SchoolBasicInfo } from './CreateEnquiry/SchoolBasicInfo';
import { AddressDetails } from './CreateEnquiry/AddressDetails';
import { RequirementDetails } from './CreateEnquiry/RequirementDetails';
import { useCreateEnquiryForm } from './CreateEnquiry/useCreateEnquiryForm';
import './CreateEnquiry/CreateEnquiry.css';

export const CreateEnquiry = () => {
    const {
        courses,
        isLoadingCourses,
        isSubmitting,
        handleSubmit,
        handleCancel
    } = useCreateEnquiryForm();

    return (
        <div className="page-content-wrapper pb-3">
            <BreadCrumb title="New Enquiry" prevPage="Enquiry" prevPath="/enquiry" />

            <form onSubmit={handleSubmit} noValidate>
                <div className="row g-3 justify-content-center align-items-stretch">
                    {/* Left Column: Photo Upload & Guide */}
                    <div className="col-12 col-lg-4 col-xl-3">
                        <PhotoUploader />
                    </div>

                    {/* Right Column: Unified Form Data Card */}
                    <div className="col-12 col-lg-8 col-xl-9">
                        <div className="card create-enquiry-card mb-0 shadow-sm h-100 d-flex flex-column justify-content-between">
                            <div className="card-header py-2.5 px-3 d-flex align-items-center justify-content-between border-bottom">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="section-icon-badge bg-soft-primary text-primary">
                                        <i className="ri-file-list-3-line"></i>
                                    </span>
                                    <div>
                                        <h5 className="card-title mb-0 fs-14 fw-semibold">New Enquiry Registration</h5>
                                        <p className="text-muted fs-11 mb-0">Fill in client & requirement details</p>
                                    </div>
                                </div>
                                <div className="d-none d-sm-flex align-items-center gap-2">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="btn btn-sm btn-light py-1 px-3 fs-12"
                                        disabled={isSubmitting}
                                    >
                                        <i className="ri-arrow-left-line me-1"></i> Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-sm btn-primary py-1 px-3 fs-12 waves-effect waves-light"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                Saving...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-save-3-line me-1"></i> Save Enquiry
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="card-body p-3 p-md-4">
                                <SchoolBasicInfo />
                                <hr className="my-3 text-muted opacity-25" />
                                <AddressDetails />
                                <hr className="my-3 text-muted opacity-25" />
                                <RequirementDetails
                                    courses={courses}
                                    isLoadingCourses={isLoadingCourses}
                                />
                            </div>
                            <div className="card-footer py-2.5 px-3 bg-light-subtle border-top d-flex justify-content-end align-items-center gap-2">
                                <button
                                    type="button"
                                    onClick={handleCancel}
                                    className="btn btn-light waves-effect px-3"
                                    disabled={isSubmitting}
                                >
                                    <i className="ri-arrow-left-line me-1"></i> Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary waves-effect waves-light px-4"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            Saving Enquiry...
                                        </>
                                    ) : (
                                        <>
                                            <i className="ri-save-3-line me-1"></i> Save Enquiry
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default CreateEnquiry;
